import ReactGA from 'react-ga4'
import { useNavigate } from 'react-router-dom'

interface ReturnsType {
  push(path: string, state?: Record<string, any>): void,
}

const useRouterPush = (): ReturnsType => {
  const navigate = useNavigate()

  const trackRouting = (page: string) => {
    ReactGA.send({ hitType: 'pageview', page })
  }

  const push = (path: string, state?: Record<string, any>) => {
    trackRouting(path)
    navigate(path, { state })
  }

  return { push }
}

export {
  useRouterPush
}
